import React from "react";
import { TabBox } from "src/Components";
import CashCalculations from "./CashCalculations";
import ExecutionManagement from "./ExecutionManagement";
import ExecutionStatus from "./ExecutionStatus";
import FundComposition from "./FundComposition";
import WatchList from "./WatchList";

enum ActiveTab {
  ExecutionManagement = 0,
  ExecutionStatus = 1,
  CashCalculations = 2,
  WatchList = 3,
  FundComposition = 4,
}

const tabsChildren = [
  { index: ActiveTab.CashCalculations, title: "محاسبات صندوق" },
  { index: ActiveTab.FundComposition, title: "ترکیب دارایی صندوق" },
  { index: ActiveTab.ExecutionManagement, title: "مدیریت اجرا" },
  { index: ActiveTab.ExecutionStatus, title: "وضعیت اجرا" },
  { index: ActiveTab.WatchList, title: "واچ لیست" },
];

const GoldArbitrage = () => {
  const [activeTab, setActiveTab] = React.useState<number>(
    ActiveTab.CashCalculations,
  );

  const Tabs = React.useMemo(() => {
    switch (activeTab) {
      case ActiveTab.ExecutionManagement:
        return <ExecutionManagement />;
      case ActiveTab.ExecutionStatus:
        return <ExecutionStatus />;
      case ActiveTab.CashCalculations:
        return <CashCalculations />;
      case ActiveTab.FundComposition:
        return <FundComposition />;
      case ActiveTab.WatchList:
        return <WatchList />;
      default:
        return <></>;
    }
  }, [activeTab]);

  return (
    <div className="flex flex-col justify-start items-start gap-3 py-2 px-4 w-full">
      <div className="w-min">
        <TabBox
          activeTab={activeTab}
          children={tabsChildren}
          onChange={(_, i) => setActiveTab(i)}
        />
      </div>
      {Tabs}
    </div>
  );
};

export default GoldArbitrage;
